import React, { useState } from 'react';
import { DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface MindMapDialogProps {
  onSave: (data: { title: string }) => void;
  onClose: () => void;
  data: {
    defaultValues?: {
      title: string;
    };
    isEditing?: boolean;
  };
}

export const MindMapDialog: React.FC<MindMapDialogProps> = ({
  onSave,
  onClose,
  data
}) => {
  const defaultValues = data?.defaultValues || { title: '' };
  const isEditing = data?.isEditing || false;
  const [title, setTitle] = useState(defaultValues.title);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ title });
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{isEditing ? 'Edit Mind Map' : 'Create New Mind Map'}</DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="title">Title</Label>
          <Input
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Mind Map title"
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" disabled={!title.trim()}>
            {isEditing ? 'Update' : 'Save'}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
};
